/** Create a timeout promise with proper cleanup */
export function createTimeoutPromise(
	timeoutMs: number,
	errorMessage = 'Operation timed out'
): { promise: Promise<never>; cleanup: () => void } {
	let timeoutId: NodeJS.Timeout

	const promise = new Promise<never>((_, reject) => {
		timeoutId = setTimeout(() => {
			reject(new Error(errorMessage))
		}, timeoutMs)
	})

	const cleanup = () => {
		if (timeoutId) {
			clearTimeout(timeoutId)
		}
	}

	return { promise, cleanup }
}

/** Race a promise against a timeout with automatic cleanup */
export async function withTimeout<T>(
	promise: Promise<T>,
	timeoutMs: number,
	errorMessage = 'Operation timed out'
): Promise<T> {
	const { promise: timeoutPromise, cleanup } = createTimeoutPromise(timeoutMs, errorMessage)

	try {
		return await Promise.race([promise, timeoutPromise])
	} finally {
		cleanup()
	}
}
